import * as Yup from 'yup';

export const filtrosSchema = Yup.object().shape({
  codigoGrupoEmpresa: Yup.number()
    .required('Selecione um Grupo Empresa')
    .positive()
    .integer(),
  codigoConta: Yup.number()
    .required('Selecione uma conta')
    .positive()
    .integer(),
  dataContabil: Yup.date()
    .required('Data contábil é obrigatória')
    .typeError('Data inválida'),
  listarSaldoZerado: Yup.boolean().default(false),
});

export const conferenciaSchema = Yup.object().shape({
  saldoConferido: Yup.number()
    .required('Saldo conferido é obrigatório')
    .typeError('Valor inválido'),
  bloqueioJudicial: Yup.number()
    .nullable()
    .min(0, 'Não pode ser negativo')
    .typeError('Valor inválido'),
  aplicacaoFinanceira: Yup.number()
    .nullable()
    .min(0, 'Não pode ser negativa')
    .typeError('Valor inválido'),
  cdb: Yup.number()
    .nullable()
    .min(0, 'Não pode ser negativo')
    .typeError('Valor inválido'),
  debito: Yup.number()
    .nullable()
    .min(0, 'Não pode ser negativo')
    .typeError('Valor inválido'),
  deposito: Yup.number()
    .nullable()
    .min(0, 'Não pode ser negativo')
    .typeError('Valor inválido'),
  observacao1: Yup.string().max(50, 'Máximo 50 caracteres'),
  observacao2: Yup.string().max(50, 'Máximo 50 caracteres'),
  observacao3: Yup.string().max(50, 'Máximo 50 caracteres'),
});
